import React, { useState } from "react";
import { Card, Input, Button, Alert, Typography } from "antd";
import axios from "axios";

const { Title, Text } = Typography;
const API_BASE = "https://kgonline.in/api";

export default function ChangeArnPassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const submit = async () => {
    setError(""); setSuccess("");
    if (!currentPassword || !newPassword || !confirmPassword) return setError("Please complete all password fields.");
    if (newPassword.length < 10) return setError("New password must be at least 10 characters.");
    if (newPassword !== confirmPassword) return setError("New passwords do not match.");
    setLoading(true);
    try {
      const token = sessionStorage.getItem("distributor_auth_token") || "";
      await axios.post(`${API_BASE}/distributor_change_password.php`,
        { current_password: currentPassword, new_password: newPassword },
        { headers: { "X-KG-Distributor-Authorization": `Bearer ${token}` } }
      );
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
      setSuccess("Login password changed successfully.");
    } catch (e) {
      setError(e?.response?.data?.message || "Unable to change password.");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: 620, margin: "0 auto" }}>
      <Card bordered={false} style={{ borderRadius: 16, boxShadow: "0 8px 24px rgba(15,23,42,.07)" }}>
        <Title level={3} style={{ marginBottom: 4 }}>Change Login Password</Title>
        <Text type="secondary">For security, passwords are never displayed on this screen.</Text>
        {error && <Alert type="error" showIcon message={error} style={{ marginTop: 18 }} />}
        {success && <Alert type="success" showIcon message={success} style={{ marginTop: 18 }} />}
        <Input.Password visibilityToggle={false} autoComplete="current-password" size="large" placeholder="Current Password" value={currentPassword} onChange={e=>setCurrentPassword(e.target.value)} style={{ marginTop: 20 }} />
        <Input.Password visibilityToggle={false} autoComplete="new-password" size="large" placeholder="New Password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} style={{ marginTop: 12 }} />
        <Input.Password visibilityToggle={false} autoComplete="new-password" size="large" placeholder="Confirm New Password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)} style={{ marginTop: 12 }} />
        <Button type="primary" size="large" block loading={loading} onClick={submit} style={{ marginTop: 18 }}>Change Password</Button>
      </Card>
    </div>
  );
}
